var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrganisedSentiumPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28125 155.738C5.28125 148.696 10.9898 142.987 18.0317 142.987H86.8844C93.9263 142.987 99.6349 148.696 99.6349 155.738C99.6349 162.779 93.9263 168.488 86.8844 168.488H18.0317C10.9898 168.488 5.28125 162.779 5.28125 155.738Z",
    fill: "#D9FFD8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28125 500C5.28125 492.959 10.9898 487.25 18.0317 487.25H86.8844C93.9263 487.25 99.6349 492.959 99.6349 500C99.6349 507.042 93.9263 512.751 86.8844 512.751H18.0317C10.9898 512.751 5.28125 507.042 5.28125 500Z",
    fill: "#D9FFD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28125 844.263C5.28125 837.222 10.9898 831.513 18.0317 831.513H86.8844C93.9263 831.513 99.6349 837.222 99.6349 844.263C99.6349 851.305 93.9263 857.014 86.8844 857.014H18.0317C10.9898 857.014 5.28125 851.305 5.28125 844.263Z",
    fill: "#D9FFD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.543 155.738C349.543 148.696 355.252 142.987 362.293 142.987H431.146C438.188 142.987 443.897 148.696 443.897 155.738C443.897 162.779 438.188 168.488 431.146 168.488H362.293C355.252 168.488 349.543 162.779 349.543 155.738Z",
    fill: "#D9FFD8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.543 500C349.543 492.959 355.252 487.25 362.293 487.25H431.146C438.188 487.25 443.897 492.959 443.897 500C443.897 507.042 438.188 512.751 431.146 512.751H362.293C355.252 512.751 349.543 507.042 349.543 500Z",
    fill: "#D9FFD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.543 844.263C349.543 837.222 355.252 831.513 362.293 831.513H431.146C438.188 831.513 443.897 837.222 443.897 844.263C443.897 851.305 438.188 857.014 431.146 857.014H362.293C355.252 857.014 349.543 851.305 349.543 844.263Z",
    fill: "#D9FFD8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.807 155.738C693.807 148.696 699.515 142.987 706.557 142.987H775.41C782.452 142.987 788.16 148.696 788.16 155.738C788.16 162.779 782.452 168.488 775.41 168.488H706.557C699.515 168.488 693.807 162.779 693.807 155.738Z",
    fill: "#D9FFD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.807 500C693.807 492.959 699.515 487.25 706.557 487.25H775.41C782.452 487.25 788.16 492.959 788.16 500C788.16 507.042 782.452 512.751 775.41 512.751H706.557C699.515 512.751 693.807 507.042 693.807 500Z",
    fill: "#D9FFD8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.807 844.263C693.807 837.222 699.515 831.513 706.557 831.513H775.41C782.452 831.513 788.16 837.222 788.16 844.263C788.16 851.305 782.452 857.014 775.41 857.014H706.557C699.515 857.014 693.807 851.305 693.807 844.263Z",
    fill: "#D9FFD8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8843 168.488C79.8424 168.488 74.1338 162.779 74.1338 155.738L74.1338 86.8849C74.1338 79.843 79.8424 74.1344 86.8843 74.1344C93.9262 74.1344 99.6348 79.843 99.6348 86.8849L99.6348 155.738C99.6348 162.779 93.9262 168.488 86.8843 168.488Z",
    fill: "#D9FFD8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8843 512.751C79.8424 512.751 74.1338 507.042 74.1338 500L74.1338 431.148C74.1338 424.106 79.8424 418.397 86.8843 418.397C93.9262 418.397 99.6348 424.106 99.6348 431.148L99.6348 500C99.6348 507.042 93.9262 512.751 86.8843 512.751Z",
    fill: "#D9FFD8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.8843 857.014C79.8424 857.014 74.1338 851.305 74.1338 844.263L74.1338 775.411C74.1338 768.369 79.8424 762.66 86.8843 762.66C93.9262 762.66 99.6348 768.369 99.6348 775.411L99.6348 844.263C99.6348 851.305 93.9262 857.014 86.8843 857.014Z",
    fill: "#D9FFD8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.148 168.488C424.106 168.488 418.397 162.779 418.397 155.738L418.397 86.8849C418.397 79.843 424.106 74.1344 431.148 74.1344C438.19 74.1344 443.898 79.843 443.898 86.8849L443.898 155.738C443.898 162.779 438.19 168.488 431.148 168.488Z",
    fill: "#D9FFD8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.148 512.751C424.106 512.751 418.397 507.042 418.397 500L418.397 431.148C418.397 424.106 424.106 418.397 431.148 418.397C438.19 418.397 443.898 424.106 443.898 431.148L443.898 500C443.898 507.042 438.19 512.751 431.148 512.751Z",
    fill: "#D9FFD8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.148 857.014C424.106 857.014 418.397 851.305 418.397 844.263L418.397 775.411C418.397 768.369 424.106 762.66 431.148 762.66C438.19 762.66 443.898 768.369 443.898 775.411L443.898 844.263C443.898 851.305 438.19 857.014 431.148 857.014Z",
    fill: "#D9FFD8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775.41 168.488C768.368 168.488 762.659 162.779 762.659 155.738L762.659 86.8849C762.659 79.843 768.368 74.1344 775.41 74.1344C782.452 74.1344 788.16 79.843 788.16 86.8849L788.16 155.738C788.16 162.779 782.452 168.488 775.41 168.488Z",
    fill: "#D9FFD8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775.41 512.751C768.368 512.751 762.659 507.042 762.659 500L762.659 431.148C762.659 424.106 768.368 418.397 775.41 418.397C782.452 418.397 788.16 424.106 788.16 431.148L788.16 500C788.16 507.042 782.452 512.751 775.41 512.751Z",
    fill: "#D9FFD8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M775.41 857.014C768.368 857.014 762.659 851.305 762.659 844.263L762.659 775.411C762.659 768.369 768.368 762.66 775.41 762.66C782.452 762.66 788.16 768.369 788.16 775.411L788.16 844.263C788.16 851.305 782.452 857.014 775.41 857.014Z",
    fill: "#D9FFD8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.589 237.341C217.547 237.341 211.839 231.632 211.839 224.59L211.839 155.738C211.839 148.696 217.547 142.987 224.589 142.987C231.631 142.987 237.34 148.696 237.34 155.738L237.34 224.59C237.34 231.632 231.631 237.341 224.589 237.341Z",
    fill: "#D9FFD8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.589 581.604C217.547 581.604 211.839 575.895 211.839 568.853L211.839 500C211.839 492.958 217.547 487.25 224.589 487.25C231.631 487.25 237.34 492.958 237.34 500L237.34 568.853C237.34 575.895 231.631 581.604 224.589 581.604Z",
    fill: "#D9FFD8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.589 925.866C217.547 925.866 211.839 920.158 211.839 913.116L211.839 844.263C211.839 837.221 217.547 831.513 224.589 831.513C231.631 831.513 237.34 837.221 237.34 844.263L237.34 913.116C237.34 920.158 231.631 925.866 224.589 925.866Z",
    fill: "#D9FFD8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.853 237.341C561.811 237.341 556.103 231.632 556.103 224.59L556.103 155.738C556.103 148.696 561.811 142.987 568.853 142.987C575.895 142.987 581.604 148.696 581.604 155.738L581.604 224.59C581.604 231.632 575.895 237.341 568.853 237.341Z",
    fill: "#D9FFD8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.853 581.604C561.811 581.604 556.103 575.895 556.103 568.853L556.103 500C556.103 492.958 561.811 487.25 568.853 487.25C575.895 487.25 581.604 492.958 581.604 500L581.604 568.853C581.604 575.895 575.895 581.604 568.853 581.604Z",
    fill: "#D9FFD8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M568.853 925.866C561.811 925.866 556.103 920.158 556.103 913.116L556.103 844.263C556.103 837.221 561.811 831.513 568.853 831.513C575.895 831.513 581.604 837.221 581.604 844.263L581.604 913.116C581.604 920.158 575.895 925.866 568.853 925.866Z",
    fill: "#D9FFD8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.115 237.341C906.073 237.341 900.364 231.632 900.364 224.59L900.364 155.738C900.364 148.696 906.073 142.987 913.115 142.987C920.157 142.987 925.865 148.696 925.865 155.738L925.865 224.59C925.865 231.632 920.157 237.341 913.115 237.341Z",
    fill: "#D9FFD8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.115 581.604C906.073 581.604 900.364 575.895 900.364 568.853L900.364 500C900.364 492.958 906.073 487.25 913.115 487.25C920.157 487.25 925.865 492.958 925.865 500L925.865 568.853C925.865 575.895 920.157 581.604 913.115 581.604Z",
    fill: "#D9FFD8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M913.115 925.866C906.073 925.866 900.364 920.158 900.364 913.116L900.364 844.263C900.364 837.221 906.073 831.513 913.115 831.513C920.157 831.513 925.865 837.221 925.865 844.263L925.865 913.116C925.865 920.158 920.157 925.866 913.115 925.866Z",
    fill: "#D9FFD8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.736 306.193C148.694 306.193 142.985 300.485 142.985 293.443L142.985 224.59C142.985 217.548 148.694 211.84 155.736 211.84C162.778 211.84 168.486 217.548 168.486 224.59L168.486 293.443C168.486 300.485 162.778 306.193 155.736 306.193Z",
    fill: "#D9FFD8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.736 650.456C148.694 650.456 142.985 644.748 142.985 637.706L142.985 568.853C142.985 561.811 148.694 556.103 155.736 556.103C162.778 556.103 168.486 561.811 168.486 568.853L168.486 637.706C168.486 644.748 162.778 650.456 155.736 650.456Z",
    fill: "#D9FFD8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.736 994.719C148.694 994.719 142.985 989.011 142.985 981.969L142.985 913.116C142.985 906.074 148.694 900.365 155.736 900.365C162.778 900.365 168.486 906.074 168.486 913.116L168.486 981.969C168.486 989.011 162.778 994.719 155.736 994.719Z",
    fill: "#D9FFD8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500 306.193C492.958 306.193 487.249 300.485 487.249 293.443L487.249 224.59C487.249 217.548 492.958 211.84 499.999 211.84C507.041 211.84 512.75 217.548 512.75 224.59L512.75 293.443C512.75 300.485 507.041 306.193 500 306.193Z",
    fill: "#D9FFD8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500 650.456C492.958 650.456 487.249 644.748 487.249 637.706L487.249 568.853C487.249 561.811 492.958 556.103 499.999 556.103C507.041 556.103 512.75 561.811 512.75 568.853L512.75 637.706C512.75 644.748 507.041 650.456 500 650.456Z",
    fill: "#D9FFD8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500 994.719C492.958 994.719 487.249 989.011 487.249 981.969L487.249 913.116C487.249 906.074 492.958 900.365 499.999 900.365C507.041 900.365 512.75 906.074 512.75 913.116L512.75 981.969C512.75 989.011 507.041 994.719 500 994.719Z",
    fill: "#D9FFD8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.263 306.193C837.221 306.193 831.513 300.485 831.513 293.443L831.513 224.59C831.513 217.548 837.221 211.84 844.263 211.84C851.305 211.84 857.014 217.548 857.014 224.59L857.014 293.443C857.014 300.485 851.305 306.193 844.263 306.193Z",
    fill: "#D9FFD8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.263 650.456C837.221 650.456 831.513 644.748 831.513 637.706L831.513 568.853C831.513 561.811 837.221 556.103 844.263 556.103C851.305 556.103 857.014 561.811 857.014 568.853L857.014 637.706C857.014 644.748 851.305 650.456 844.263 650.456Z",
    fill: "#D9FFD8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.263 994.719C837.221 994.719 831.513 989.011 831.513 981.969L831.513 913.116C831.513 906.074 837.221 900.365 844.263 900.365C851.305 900.365 857.014 906.074 857.014 913.116L857.014 981.969C857.014 989.011 851.305 994.719 844.263 994.719Z",
    fill: "#D9FFD8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.736 99.6355C148.694 99.6355 142.985 93.9269 142.985 86.885L142.985 18.0323C142.985 10.9904 148.694 5.28185 155.736 5.28185C162.778 5.28185 168.486 10.9904 168.486 18.0323L168.486 86.885C168.486 93.9269 162.778 99.6355 155.736 99.6355Z",
    fill: "#D9FFD8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.736 443.898C148.694 443.898 142.985 438.19 142.985 431.148L142.985 362.295C142.985 355.253 148.694 349.545 155.736 349.545C162.778 349.545 168.486 355.253 168.486 362.295L168.486 431.148C168.486 438.19 162.778 443.898 155.736 443.898Z",
    fill: "#D9FFD8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.736 788.161C148.694 788.161 142.985 782.453 142.985 775.411L142.985 706.558C142.985 699.516 148.694 693.808 155.736 693.808C162.778 693.808 168.486 699.516 168.486 706.558L168.486 775.411C168.486 782.453 162.778 788.161 155.736 788.161Z",
    fill: "#D9FFD8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500 99.6355C492.958 99.6355 487.249 93.9269 487.249 86.885L487.249 18.0323C487.249 10.9904 492.958 5.28185 499.999 5.28185C507.041 5.28185 512.75 10.9904 512.75 18.0323L512.75 86.885C512.75 93.9269 507.041 99.6355 500 99.6355Z",
    fill: "#D9FFD8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500 443.898C492.958 443.898 487.249 438.19 487.249 431.148L487.249 362.295C487.249 355.253 492.958 349.545 499.999 349.545C507.041 349.545 512.75 355.253 512.75 362.295L512.75 431.148C512.75 438.19 507.041 443.898 500 443.898Z",
    fill: "#D9FFD8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M500 788.161C492.958 788.161 487.249 782.453 487.249 775.411L487.249 706.558C487.249 699.516 492.958 693.808 499.999 693.808C507.041 693.808 512.75 699.516 512.75 706.558L512.75 775.411C512.75 782.453 507.041 788.161 500 788.161Z",
    fill: "#D9FFD8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.263 99.6355C837.221 99.6355 831.513 93.9269 831.513 86.885L831.513 18.0323C831.513 10.9904 837.221 5.28185 844.263 5.28185C851.305 5.28185 857.014 10.9904 857.014 18.0323L857.014 86.885C857.014 93.9269 851.305 99.6355 844.263 99.6355Z",
    fill: "#D9FFD8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.263 443.898C837.221 443.898 831.513 438.19 831.513 431.148L831.513 362.295C831.513 355.253 837.221 349.545 844.263 349.545C851.305 349.545 857.014 355.253 857.014 362.295L857.014 431.148C857.014 438.19 851.305 443.898 844.263 443.898Z",
    fill: "#D9FFD8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M844.263 788.161C837.221 788.161 831.513 782.453 831.513 775.411L831.513 706.558C831.513 699.516 837.221 693.808 844.263 693.808C851.305 693.808 857.014 699.516 857.014 706.558L857.014 775.411C857.014 782.453 851.305 788.161 844.263 788.161Z",
    fill: "#D9FFD8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.838 155.738C211.838 148.696 217.546 142.987 224.588 142.987H293.441C300.483 142.987 306.192 148.696 306.192 155.738C306.192 162.779 300.483 168.488 293.441 168.488H224.588C217.546 168.488 211.838 162.779 211.838 155.738Z",
    fill: "#D9FFD8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.838 500C211.838 492.959 217.546 487.25 224.588 487.25H293.441C300.483 487.25 306.192 492.959 306.192 500C306.192 507.042 300.483 512.751 293.441 512.751H224.588C217.546 512.751 211.838 507.042 211.838 500Z",
    fill: "#D9FFD8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.838 844.263C211.838 837.222 217.546 831.513 224.588 831.513H293.441C300.483 831.513 306.192 837.222 306.192 844.263C306.192 851.305 300.483 857.014 293.441 857.014H224.588C217.546 857.014 211.838 851.305 211.838 844.263Z",
    fill: "#D9FFD8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.102 155.738C556.102 148.696 561.81 142.987 568.852 142.987H637.705C644.747 142.987 650.455 148.696 650.455 155.738C650.455 162.779 644.747 168.488 637.705 168.488H568.852C561.81 168.488 556.102 162.779 556.102 155.738Z",
    fill: "#D9FFD8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.102 500C556.102 492.959 561.81 487.25 568.852 487.25H637.705C644.747 487.25 650.455 492.959 650.455 500C650.455 507.042 644.747 512.751 637.705 512.751H568.852C561.81 512.751 556.102 507.042 556.102 500Z",
    fill: "#D9FFD8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.102 844.263C556.102 837.222 561.81 831.513 568.852 831.513H637.705C644.747 831.513 650.455 837.222 650.455 844.263C650.455 851.305 644.747 857.014 637.705 857.014H568.852C561.81 857.014 556.102 851.305 556.102 844.263Z",
    fill: "#D9FFD8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M900.365 155.738C900.365 148.696 906.074 142.987 913.116 142.987H981.968C989.01 142.987 994.719 148.696 994.719 155.738C994.719 162.779 989.01 168.488 981.968 168.488H913.116C906.074 168.488 900.365 162.779 900.365 155.738Z",
    fill: "#D9FFD8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M900.365 500C900.365 492.959 906.074 487.25 913.116 487.25H981.968C989.01 487.25 994.719 492.959 994.719 500C994.719 507.042 989.01 512.751 981.968 512.751H913.116C906.074 512.751 900.365 507.042 900.365 500Z",
    fill: "#D9FFD8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M900.365 844.263C900.365 837.222 906.074 831.513 913.116 831.513H981.968C989.01 831.513 994.719 837.222 994.719 844.263C994.719 851.305 989.01 857.014 981.968 857.014H913.116C906.074 857.014 900.365 851.305 900.365 844.263Z",
    fill: "#D9FFD8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.573 9.01651C220.552 4.03713 228.625 4.03714 233.605 9.01651L302.457 77.8692C307.437 82.8486 307.437 90.9217 302.457 95.9011C297.478 100.88 289.405 100.88 284.425 95.9011L215.573 27.0484C210.593 22.0691 210.593 13.9959 215.573 9.01651Z",
    fill: "#D9FFD8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.573 353.279C220.552 348.3 228.625 348.3 233.605 353.279L302.457 422.132C307.437 427.111 307.437 435.185 302.457 440.164C297.478 445.143 289.405 445.143 284.425 440.164L215.573 371.311C210.593 366.332 210.593 358.259 215.573 353.279Z",
    fill: "#D9FFD8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.573 697.542C220.552 692.563 228.625 692.563 233.605 697.542L302.457 766.395C307.437 771.374 307.437 779.448 302.457 784.427C297.478 789.406 289.405 789.406 284.425 784.427L215.573 715.574C210.593 710.595 210.593 702.522 215.573 697.542Z",
    fill: "#D9FFD8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.836 9.01651C564.816 4.03713 572.889 4.03714 577.868 9.01651L646.721 77.8692C651.7 82.8486 651.7 90.9217 646.721 95.9011C641.741 100.88 633.668 100.88 628.689 95.9011L559.836 27.0484C554.857 22.0691 554.857 13.9959 559.836 9.01651Z",
    fill: "#D9FFD8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.836 353.279C564.816 348.3 572.889 348.3 577.868 353.279L646.721 422.132C651.7 427.111 651.7 435.185 646.721 440.164C641.741 445.143 633.668 445.143 628.689 440.164L559.836 371.311C554.857 366.332 554.857 358.259 559.836 353.279Z",
    fill: "#D9FFD8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.836 697.542C564.816 692.563 572.889 692.563 577.868 697.542L646.721 766.395C651.7 771.374 651.7 779.448 646.721 784.427C641.741 789.406 633.668 789.406 628.689 784.427L559.836 715.574C554.857 710.595 554.857 702.522 559.836 697.542Z",
    fill: "#D9FFD8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.098 9.01651C909.077 4.03713 917.151 4.03714 922.13 9.01651L990.983 77.8692C995.962 82.8486 995.962 90.9217 990.983 95.9011C986.003 100.88 977.93 100.88 972.951 95.9011L904.098 27.0484C899.119 22.0691 899.119 13.9959 904.098 9.01651Z",
    fill: "#D9FFD8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.098 353.279C909.077 348.3 917.151 348.3 922.13 353.279L990.983 422.132C995.962 427.111 995.962 435.185 990.983 440.164C986.003 445.143 977.93 445.143 972.951 440.164L904.098 371.311C899.119 366.332 899.119 358.259 904.098 353.279Z",
    fill: "#D9FFD8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.098 697.542C909.077 692.563 917.151 692.563 922.13 697.542L990.983 766.395C995.962 771.374 995.962 779.448 990.983 784.427C986.003 789.406 977.93 789.406 972.951 784.427L904.098 715.574C899.119 710.595 899.119 702.522 904.098 697.542Z",
    fill: "#D9FFD8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9001 9.01651C90.9207 4.03714 82.8475 4.03714 77.8681 9.01652L9.01549 77.8692C4.03611 82.8486 4.03612 90.9217 9.01549 95.9011C13.9949 100.88 22.068 100.88 27.0474 95.9011L95.9001 27.0484C100.879 22.0691 100.879 13.9959 95.9001 9.01651Z",
    fill: "#D9FFD8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9001 353.279C90.9207 348.3 82.8475 348.3 77.8681 353.279L9.01549 422.132C4.03611 427.112 4.03612 435.185 9.01549 440.164C13.9949 445.143 22.068 445.143 27.0474 440.164L95.9001 371.311C100.879 366.332 100.879 358.259 95.9001 353.279Z",
    fill: "#D9FFD8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9001 697.542C90.9207 692.563 82.8475 692.563 77.8681 697.542L9.01549 766.395C4.03611 771.374 4.03612 779.448 9.01549 784.427C13.9949 789.406 22.068 789.406 27.0474 784.427L95.9001 715.574C100.879 710.595 100.879 702.522 95.9001 697.542Z",
    fill: "#D9FFD8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.164 9.01651C435.184 4.03714 427.111 4.03714 422.132 9.01652L353.279 77.8692C348.3 82.8486 348.3 90.9217 353.279 95.9011C358.259 100.88 366.332 100.88 371.311 95.9011L440.164 27.0484C445.143 22.0691 445.143 13.9959 440.164 9.01651Z",
    fill: "#D9FFD8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.164 353.279C435.184 348.3 427.111 348.3 422.132 353.279L353.279 422.132C348.3 427.112 348.3 435.185 353.279 440.164C358.259 445.143 366.332 445.143 371.311 440.164L440.164 371.311C445.143 366.332 445.143 358.259 440.164 353.279Z",
    fill: "#D9FFD8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.164 697.542C435.184 692.563 427.111 692.563 422.132 697.542L353.279 766.395C348.3 771.374 348.3 779.448 353.279 784.427C358.259 789.406 366.332 789.406 371.311 784.427L440.164 715.574C445.143 710.595 445.143 702.522 440.164 697.542Z",
    fill: "#D9FFD8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M784.425 9.01651C779.446 4.03714 771.373 4.03714 766.394 9.01652L697.541 77.8692C692.562 82.8486 692.562 90.9217 697.541 95.9011C702.52 100.88 710.593 100.88 715.573 95.9011L784.425 27.0484C789.405 22.0691 789.405 13.9959 784.425 9.01651Z",
    fill: "#D9FFD8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M784.425 353.279C779.446 348.3 771.373 348.3 766.394 353.279L697.541 422.132C692.562 427.112 692.562 435.185 697.541 440.164C702.52 445.143 710.593 445.143 715.573 440.164L784.425 371.311C789.405 366.332 789.405 358.259 784.425 353.279Z",
    fill: "#D9FFD8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M784.425 697.542C779.446 692.563 771.373 692.563 766.394 697.542L697.541 766.395C692.562 771.374 692.562 779.448 697.541 784.427C702.52 789.406 710.593 789.406 715.573 784.427L784.425 715.574C789.405 710.595 789.405 702.522 784.425 697.542Z",
    fill: "#D9FFD8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9001 302.459C90.9207 307.438 82.8475 307.438 77.8681 302.459L9.01548 233.606C4.03611 228.627 4.03611 220.553 9.01549 215.574C13.9949 210.595 22.068 210.595 27.0474 215.574L95.9001 284.427C100.879 289.406 100.879 297.479 95.9001 302.459Z",
    fill: "#D9FFD8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9001 646.722C90.9207 651.701 82.8475 651.701 77.8681 646.722L9.01548 577.869C4.03611 572.89 4.03611 564.816 9.01549 559.837C13.9949 554.858 22.068 554.858 27.0474 559.837L95.9001 628.69C100.879 633.669 100.879 641.742 95.9001 646.722Z",
    fill: "#D9FFD8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9001 990.985C90.9207 995.964 82.8475 995.964 77.8681 990.985L9.01548 922.132C4.03611 917.153 4.03611 909.079 9.01549 904.1C13.9949 899.121 22.068 899.121 27.0474 904.1L95.9001 972.953C100.879 977.932 100.879 986.005 95.9001 990.985Z",
    fill: "#D9FFD8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.164 302.459C435.184 307.438 427.111 307.438 422.132 302.459L353.279 233.606C348.3 228.627 348.3 220.553 353.279 215.574C358.259 210.595 366.332 210.595 371.311 215.574L440.164 284.427C445.143 289.406 445.143 297.479 440.164 302.459Z",
    fill: "#D9FFD8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.164 646.722C435.184 651.701 427.111 651.701 422.132 646.722L353.279 577.869C348.3 572.89 348.3 564.816 353.279 559.837C358.259 554.858 366.332 554.858 371.311 559.837L440.164 628.69C445.143 633.669 445.143 641.742 440.164 646.722Z",
    fill: "#D9FFD8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M440.164 990.985C435.184 995.964 427.111 995.964 422.132 990.985L353.279 922.132C348.3 917.153 348.3 909.079 353.279 904.1C358.259 899.121 366.332 899.121 371.311 904.1L440.164 972.953C445.143 977.932 445.143 986.005 440.164 990.985Z",
    fill: "#D9FFD8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M784.425 302.459C779.446 307.438 771.373 307.438 766.394 302.459L697.541 233.606C692.561 228.627 692.561 220.553 697.541 215.574C702.52 210.595 710.593 210.595 715.573 215.574L784.425 284.427C789.405 289.406 789.405 297.479 784.425 302.459Z",
    fill: "#D9FFD8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M784.425 646.722C779.446 651.701 771.373 651.701 766.394 646.722L697.541 577.869C692.561 572.89 692.561 564.816 697.541 559.837C702.52 554.858 710.593 554.858 715.573 559.837L784.425 628.69C789.405 633.669 789.405 641.742 784.425 646.722Z",
    fill: "#D9FFD8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M784.425 990.985C779.446 995.964 771.373 995.964 766.394 990.985L697.541 922.132C692.561 917.153 692.561 909.079 697.541 904.1C702.52 899.121 710.593 899.121 715.573 904.1L784.425 972.953C789.405 977.932 789.405 986.005 784.425 990.985Z",
    fill: "#D9FFD8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.573 302.459C220.552 307.438 228.625 307.438 233.605 302.459L302.457 233.606C307.437 228.627 307.437 220.553 302.457 215.574C297.478 210.595 289.405 210.595 284.425 215.574L215.573 284.427C210.593 289.406 210.593 297.479 215.573 302.459Z",
    fill: "#D9FFD8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.573 646.722C220.552 651.701 228.625 651.701 233.605 646.722L302.457 577.869C307.437 572.89 307.437 564.816 302.457 559.837C297.478 554.858 289.405 554.858 284.425 559.837L215.573 628.69C210.593 633.669 210.593 641.742 215.573 646.722Z",
    fill: "#D9FFD8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M215.573 990.985C220.552 995.964 228.625 995.964 233.605 990.985L302.457 922.132C307.437 917.153 307.437 909.079 302.457 904.1C297.478 899.121 289.405 899.121 284.425 904.1L215.573 972.953C210.593 977.932 210.593 986.005 215.573 990.985Z",
    fill: "#D9FFD8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.836 302.459C564.816 307.438 572.889 307.438 577.868 302.459L646.721 233.606C651.7 228.627 651.7 220.553 646.721 215.574C641.741 210.595 633.668 210.595 628.689 215.574L559.836 284.427C554.857 289.406 554.857 297.479 559.836 302.459Z",
    fill: "#D9FFD8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.836 646.722C564.816 651.701 572.889 651.701 577.868 646.722L646.721 577.869C651.7 572.89 651.7 564.816 646.721 559.837C641.741 554.858 633.668 554.858 628.689 559.837L559.836 628.69C554.857 633.669 554.857 641.742 559.836 646.722Z",
    fill: "#D9FFD8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M559.836 990.985C564.816 995.964 572.889 995.964 577.868 990.985L646.721 922.132C651.7 917.153 651.7 909.079 646.721 904.1C641.741 899.121 633.668 899.121 628.689 904.1L559.836 972.953C554.857 977.932 554.857 986.005 559.836 990.985Z",
    fill: "#D9FFD8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.098 302.459C909.077 307.438 917.151 307.438 922.13 302.459L990.983 233.606C995.962 228.627 995.962 220.553 990.983 215.574C986.003 210.595 977.93 210.595 972.951 215.574L904.098 284.427C899.119 289.406 899.119 297.479 904.098 302.459Z",
    fill: "#D9FFD8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.098 646.722C909.077 651.701 917.151 651.701 922.13 646.722L990.983 577.869C995.962 572.89 995.962 564.816 990.983 559.837C986.003 554.858 977.93 554.858 972.951 559.837L904.098 628.69C899.119 633.669 899.119 641.742 904.098 646.722Z",
    fill: "#D9FFD8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M904.098 990.985C909.077 995.964 917.151 995.964 922.13 990.985L990.983 922.132C995.962 917.153 995.962 909.079 990.983 904.1C986.003 899.121 977.93 899.121 972.951 904.1L904.098 972.953C899.119 977.932 899.119 986.005 904.098 990.985Z",
    fill: "#D9FFD8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.721 9.01651C151.7 4.03713 159.774 4.03713 164.753 9.01651L233.606 77.8692C238.585 82.8486 238.585 90.9217 233.606 95.9011C228.626 100.88 220.553 100.88 215.574 95.9011L146.721 27.0484C141.742 22.0691 141.742 13.9959 146.721 9.01651Z",
    fill: "#D9FFD8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.721 353.279C151.7 348.3 159.774 348.3 164.753 353.279L233.606 422.132C238.585 427.111 238.585 435.185 233.606 440.164C228.626 445.143 220.553 445.143 215.574 440.164L146.721 371.311C141.742 366.332 141.742 358.259 146.721 353.279Z",
    fill: "#D9FFD8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.721 697.542C151.7 692.563 159.774 692.563 164.753 697.542L233.606 766.395C238.585 771.374 238.585 779.448 233.606 784.427C228.626 789.406 220.553 789.406 215.574 784.427L146.721 715.574C141.742 710.595 141.742 702.522 146.721 697.542Z",
    fill: "#D9FFD8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.983 9.01651C495.962 4.03713 504.035 4.03713 509.015 9.01651L577.867 77.8692C582.847 82.8486 582.847 90.9217 577.867 95.9011C572.888 100.88 564.815 100.88 559.835 95.9011L490.983 27.0484C486.003 22.0691 486.003 13.9959 490.983 9.01651Z",
    fill: "#D9FFD8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.983 353.279C495.962 348.3 504.035 348.3 509.015 353.279L577.867 422.132C582.847 427.111 582.847 435.185 577.867 440.164C572.888 445.143 564.815 445.143 559.835 440.164L490.983 371.311C486.003 366.332 486.003 358.259 490.983 353.279Z",
    fill: "#D9FFD8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.983 697.542C495.962 692.563 504.035 692.563 509.015 697.542L577.867 766.395C582.847 771.374 582.847 779.448 577.867 784.427C572.888 789.406 564.815 789.406 559.835 784.427L490.983 715.574C486.003 710.595 486.003 702.522 490.983 697.542Z",
    fill: "#D9FFD8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.246 9.01651C840.226 4.03713 848.299 4.03713 853.278 9.01651L922.131 77.8692C927.11 82.8486 927.11 90.9217 922.131 95.9011C917.152 100.88 909.078 100.88 904.099 95.9011L835.246 27.0484C830.267 22.0691 830.267 13.9959 835.246 9.01651Z",
    fill: "#D9FFD8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.246 353.279C840.226 348.3 848.299 348.3 853.278 353.279L922.131 422.132C927.11 427.111 927.11 435.185 922.131 440.164C917.152 445.143 909.078 445.143 904.099 440.164L835.246 371.311C830.267 366.332 830.267 358.259 835.246 353.279Z",
    fill: "#D9FFD8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M835.246 697.542C840.226 692.563 848.299 692.563 853.278 697.542L922.131 766.395C927.11 771.374 927.11 779.448 922.131 784.427C917.152 789.406 909.078 789.406 904.099 784.427L835.246 715.574C830.267 710.595 830.267 702.522 835.246 697.542Z",
    fill: "#D9FFD8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8675 215.574C82.8469 210.595 90.9201 210.595 95.8994 215.574L164.752 284.427C169.731 289.406 169.731 297.479 164.752 302.459C159.773 307.438 151.7 307.438 146.72 302.459L77.8675 233.606C72.8881 228.627 72.8881 220.554 77.8675 215.574Z",
    fill: "#D9FFD8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8675 559.837C82.8469 554.858 90.9201 554.858 95.8994 559.837L164.752 628.69C169.731 633.669 169.731 641.742 164.752 646.722C159.773 651.701 151.7 651.701 146.72 646.722L77.8675 577.869C72.8881 572.89 72.8881 564.816 77.8675 559.837Z",
    fill: "#D9FFD8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8675 904.1C82.8469 899.121 90.9201 899.121 95.8994 904.1L164.752 972.953C169.731 977.932 169.731 986.005 164.752 990.985C159.773 995.964 151.7 995.964 146.72 990.985L77.8675 922.132C72.8881 917.153 72.8881 909.079 77.8675 904.1Z",
    fill: "#D9FFD8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.131 215.574C427.111 210.595 435.184 210.595 440.163 215.574L509.016 284.427C513.995 289.406 513.995 297.479 509.016 302.459C504.036 307.438 495.963 307.438 490.984 302.459L422.131 233.606C417.152 228.627 417.152 220.554 422.131 215.574Z",
    fill: "#D9FFD8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.131 559.837C427.111 554.858 435.184 554.858 440.163 559.837L509.016 628.69C513.995 633.669 513.995 641.742 509.016 646.722C504.036 651.701 495.963 651.701 490.984 646.722L422.131 577.869C417.152 572.89 417.152 564.816 422.131 559.837Z",
    fill: "#D9FFD8"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M422.131 904.1C427.111 899.121 435.184 899.121 440.163 904.1L509.016 972.953C513.995 977.932 513.995 986.005 509.016 990.985C504.036 995.964 495.963 995.964 490.984 990.985L422.131 922.132C417.152 917.153 417.152 909.079 422.131 904.1Z",
    fill: "#D9FFD8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.393 215.574C771.372 210.595 779.445 210.595 784.425 215.574L853.277 284.427C858.257 289.406 858.257 297.479 853.277 302.459C848.298 307.438 840.225 307.438 835.246 302.459L766.393 233.606C761.414 228.627 761.414 220.554 766.393 215.574Z",
    fill: "#D9FFD8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.393 559.837C771.372 554.858 779.445 554.858 784.425 559.837L853.277 628.69C858.257 633.669 858.257 641.742 853.277 646.722C848.298 651.701 840.225 651.701 835.246 646.722L766.393 577.869C761.414 572.89 761.414 564.816 766.393 559.837Z",
    fill: "#D9FFD8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M766.393 904.1C771.372 899.121 779.445 899.121 784.425 904.1L853.277 972.953C858.257 977.932 858.257 986.005 853.277 990.985C848.298 995.964 840.225 995.964 835.246 990.985L766.393 922.132C761.414 917.153 761.414 909.079 766.393 904.1Z",
    fill: "#D9FFD8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.838 18.0325C211.838 10.9906 217.546 5.28197 224.588 5.28197L293.441 5.28197C300.483 5.28197 306.192 10.9906 306.192 18.0325C306.192 25.0744 300.483 30.783 293.441 30.783L224.588 30.783C217.546 30.783 211.838 25.0744 211.838 18.0325Z",
    fill: "#D9FFD8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.838 362.295C211.838 355.254 217.546 349.545 224.588 349.545L293.441 349.545C300.483 349.545 306.192 355.254 306.192 362.295C306.192 369.337 300.483 375.046 293.441 375.046L224.588 375.046C217.546 375.046 211.838 369.337 211.838 362.295Z",
    fill: "#D9FFD8"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.838 706.558C211.838 699.516 217.546 693.808 224.588 693.808L293.441 693.808C300.483 693.808 306.192 699.516 306.192 706.558C306.192 713.6 300.483 719.309 293.441 719.309L224.588 719.309C217.546 719.309 211.838 713.6 211.838 706.558Z",
    fill: "#D9FFD8"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.102 18.0325C556.102 10.9906 561.81 5.28197 568.852 5.28197L637.705 5.28197C644.747 5.28197 650.455 10.9906 650.455 18.0325C650.455 25.0744 644.747 30.783 637.705 30.783L568.852 30.783C561.81 30.783 556.102 25.0744 556.102 18.0325Z",
    fill: "#D9FFD8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.102 362.295C556.102 355.254 561.81 349.545 568.852 349.545L637.705 349.545C644.747 349.545 650.455 355.254 650.455 362.295C650.455 369.337 644.747 375.046 637.705 375.046L568.852 375.046C561.81 375.046 556.102 369.337 556.102 362.295Z",
    fill: "#D9FFD8"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M556.102 706.558C556.102 699.516 561.81 693.808 568.852 693.808L637.705 693.808C644.747 693.808 650.455 699.516 650.455 706.558C650.455 713.6 644.747 719.309 637.705 719.309L568.852 719.309C561.81 719.309 556.102 713.6 556.102 706.558Z",
    fill: "#D9FFD8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M900.365 18.0325C900.365 10.9906 906.074 5.28197 913.116 5.28197L981.968 5.28197C989.01 5.28197 994.719 10.9906 994.719 18.0325C994.719 25.0744 989.01 30.783 981.968 30.783L913.116 30.783C906.074 30.783 900.365 25.0744 900.365 18.0325Z",
    fill: "#D9FFD8"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M900.365 362.295C900.365 355.254 906.074 349.545 913.116 349.545L981.968 349.545C989.01 349.545 994.719 355.254 994.719 362.295C994.719 369.337 989.01 375.046 981.968 375.046L913.116 375.046C906.074 375.046 900.365 369.337 900.365 362.295Z",
    fill: "#D9FFD8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M900.365 706.558C900.365 699.516 906.074 693.808 913.116 693.808L981.968 693.808C989.01 693.808 994.719 699.516 994.719 706.558C994.719 713.6 989.01 719.309 981.968 719.309L913.116 719.309C906.074 719.309 900.365 713.6 900.365 706.558Z",
    fill: "#D9FFD8"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6348 18.0325C99.6348 10.9906 93.9262 5.28197 86.8843 5.28197L18.0316 5.28199C10.9897 5.28199 5.28111 10.9906 5.28111 18.0325C5.28111 25.0744 10.9897 30.783 18.0316 30.783L86.8843 30.783C93.9262 30.783 99.6348 25.0744 99.6348 18.0325Z",
    fill: "#D9FFD8"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6348 362.295C99.6348 355.254 93.9262 349.545 86.8843 349.545L18.0316 349.545C10.9897 349.545 5.28111 355.254 5.28111 362.295C5.28111 369.337 10.9897 375.046 18.0316 375.046L86.8843 375.046C93.9262 375.046 99.6348 369.337 99.6348 362.295Z",
    fill: "#D9FFD8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.6348 706.558C99.6348 699.516 93.9262 693.808 86.8843 693.808L18.0316 693.808C10.9897 693.808 5.28111 699.516 5.28111 706.558C5.28111 713.6 10.9897 719.309 18.0316 719.309L86.8843 719.309C93.9262 719.309 99.6348 713.6 99.6348 706.558Z",
    fill: "#D9FFD8"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.898 18.0325C443.898 10.9906 438.19 5.28197 431.148 5.28197L362.295 5.28199C355.253 5.28199 349.545 10.9906 349.545 18.0325C349.545 25.0744 355.253 30.783 362.295 30.783L431.148 30.783C438.19 30.783 443.898 25.0744 443.898 18.0325Z",
    fill: "#D9FFD8"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.898 362.295C443.898 355.254 438.19 349.545 431.148 349.545L362.295 349.545C355.253 349.545 349.545 355.254 349.545 362.295C349.545 369.337 355.253 375.046 362.295 375.046L431.148 375.046C438.19 375.046 443.898 369.337 443.898 362.295Z",
    fill: "#D9FFD8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M443.898 706.558C443.898 699.516 438.19 693.808 431.148 693.808L362.295 693.808C355.253 693.808 349.545 699.516 349.545 706.558C349.545 713.6 355.253 719.309 362.295 719.309L431.148 719.309C438.19 719.309 443.898 713.6 443.898 706.558Z",
    fill: "#D9FFD8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.16 18.0325C788.16 10.9906 782.452 5.28197 775.41 5.28197L706.557 5.28199C699.515 5.28199 693.807 10.9906 693.807 18.0325C693.807 25.0744 699.515 30.783 706.557 30.783L775.41 30.783C782.452 30.783 788.16 25.0744 788.16 18.0325Z",
    fill: "#D9FFD8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.16 362.295C788.16 355.254 782.452 349.545 775.41 349.545L706.557 349.545C699.515 349.545 693.807 355.254 693.807 362.295C693.807 369.337 699.515 375.046 706.557 375.046L775.41 375.046C782.452 375.046 788.16 369.337 788.16 362.295Z",
    fill: "#D9FFD8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M788.16 706.558C788.16 699.516 782.452 693.808 775.41 693.808L706.557 693.808C699.515 693.808 693.807 699.516 693.807 706.558C693.807 713.6 699.515 719.309 706.557 719.309L775.41 719.309C782.452 719.309 788.16 713.6 788.16 706.558Z",
    fill: "#D9FFD8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28125 293.443C5.28125 286.401 10.9898 280.692 18.0317 280.692L86.8844 280.692C93.9263 280.692 99.6349 286.401 99.6349 293.443C99.6349 300.485 93.9263 306.193 86.8844 306.193L18.0317 306.193C10.9898 306.193 5.28125 300.485 5.28125 293.443Z",
    fill: "#D9FFD8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28125 637.706C5.28125 630.664 10.9898 624.955 18.0317 624.955L86.8844 624.955C93.9263 624.955 99.6349 630.664 99.6349 637.706C99.6349 644.748 93.9263 650.456 86.8844 650.456L18.0317 650.456C10.9898 650.456 5.28125 644.748 5.28125 637.706Z",
    fill: "#D9FFD8"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28125 981.969C5.28125 974.927 10.9898 969.218 18.0317 969.218L86.8844 969.218C93.9263 969.218 99.6349 974.927 99.6349 981.969C99.6349 989.011 93.9263 994.719 86.8844 994.719L18.0317 994.719C10.9898 994.719 5.28125 989.011 5.28125 981.969Z",
    fill: "#D9FFD8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.543 293.443C349.543 286.401 355.252 280.692 362.293 280.692L431.146 280.692C438.188 280.692 443.897 286.401 443.897 293.443C443.897 300.485 438.188 306.193 431.146 306.193L362.293 306.193C355.252 306.193 349.543 300.485 349.543 293.443Z",
    fill: "#D9FFD8"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.543 637.706C349.543 630.664 355.252 624.955 362.293 624.955L431.146 624.955C438.188 624.955 443.897 630.664 443.897 637.706C443.897 644.748 438.188 650.456 431.146 650.456L362.293 650.456C355.252 650.456 349.543 644.748 349.543 637.706Z",
    fill: "#D9FFD8"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.543 981.969C349.543 974.927 355.252 969.218 362.293 969.218L431.146 969.218C438.188 969.218 443.897 974.927 443.897 981.969C443.897 989.011 438.188 994.719 431.146 994.719L362.293 994.719C355.252 994.719 349.543 989.011 349.543 981.969Z",
    fill: "#D9FFD8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.807 293.443C693.807 286.401 699.515 280.692 706.557 280.692L775.41 280.692C782.452 280.692 788.16 286.401 788.16 293.443C788.16 300.485 782.452 306.193 775.41 306.193L706.557 306.193C699.515 306.193 693.807 300.485 693.807 293.443Z",
    fill: "#D9FFD8"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.807 637.706C693.807 630.664 699.515 624.955 706.557 624.955L775.41 624.955C782.452 624.955 788.16 630.664 788.16 637.706C788.16 644.748 782.452 650.456 775.41 650.456L706.557 650.456C699.515 650.456 693.807 644.748 693.807 637.706Z",
    fill: "#D9FFD8"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M693.807 981.969C693.807 974.927 699.515 969.218 706.557 969.218L775.41 969.218C782.452 969.218 788.16 974.927 788.16 981.969C788.16 989.011 782.452 994.719 775.41 994.719L706.557 994.719C699.515 994.719 693.807 989.011 693.807 981.969Z",
    fill: "#D9FFD8"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.191 293.443C306.191 286.401 300.483 280.692 293.441 280.692L224.588 280.692C217.546 280.692 211.838 286.401 211.838 293.443C211.838 300.485 217.546 306.193 224.588 306.193L293.441 306.193C300.483 306.193 306.191 300.485 306.191 293.443Z",
    fill: "#D9FFD8"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.191 637.706C306.191 630.664 300.483 624.955 293.441 624.955L224.588 624.955C217.546 624.955 211.838 630.664 211.838 637.706C211.838 644.748 217.546 650.456 224.588 650.456L293.441 650.456C300.483 650.456 306.191 644.748 306.191 637.706Z",
    fill: "#D9FFD8"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.191 981.969C306.191 974.927 300.483 969.218 293.441 969.218L224.588 969.218C217.546 969.218 211.838 974.927 211.838 981.969C211.838 989.011 217.546 994.719 224.588 994.719L293.441 994.719C300.483 994.719 306.191 989.011 306.191 981.969Z",
    fill: "#D9FFD8"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.455 293.443C650.455 286.401 644.746 280.692 637.705 280.692L568.852 280.692C561.81 280.692 556.101 286.401 556.101 293.443C556.101 300.485 561.81 306.193 568.852 306.193L637.705 306.193C644.746 306.193 650.455 300.485 650.455 293.443Z",
    fill: "#D9FFD8"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.455 637.706C650.455 630.664 644.746 624.955 637.705 624.955L568.852 624.955C561.81 624.955 556.101 630.664 556.101 637.706C556.101 644.748 561.81 650.456 568.852 650.456L637.705 650.456C644.746 650.456 650.455 644.748 650.455 637.706Z",
    fill: "#D9FFD8"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M650.455 981.969C650.455 974.927 644.746 969.218 637.705 969.218L568.852 969.218C561.81 969.218 556.101 974.927 556.101 981.969C556.101 989.011 561.81 994.719 568.852 994.719L637.705 994.719C644.746 994.719 650.455 989.011 650.455 981.969Z",
    fill: "#D9FFD8"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.719 293.443C994.719 286.401 989.01 280.692 981.968 280.692L913.116 280.692C906.074 280.692 900.365 286.401 900.365 293.443C900.365 300.485 906.074 306.193 913.116 306.193L981.968 306.193C989.01 306.193 994.719 300.485 994.719 293.443Z",
    fill: "#D9FFD8"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.719 637.706C994.719 630.664 989.01 624.955 981.968 624.955L913.116 624.955C906.074 624.955 900.365 630.664 900.365 637.706C900.365 644.748 906.074 650.456 913.116 650.456L981.968 650.456C989.01 650.456 994.719 644.748 994.719 637.706Z",
    fill: "#D9FFD8"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M994.719 981.969C994.719 974.927 989.01 969.218 981.968 969.218L913.116 969.218C906.074 969.218 900.365 974.927 900.365 981.969C900.365 989.011 906.074 994.719 913.116 994.719L981.968 994.719C989.01 994.719 994.719 989.011 994.719 981.969Z",
    fill: "#D9FFD8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisedSentiumPattern);
export default __webpack_public_path__ + "static/media/organised_sentium_pattern.6b7ba863ae8dd6b7b6e4d04614077296.svg";
export { ForwardRef as ReactComponent };